import { Alert, AlertTitle } from '@mui/material';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: any;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(errorInfo);

    console.error(error);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Alert severity="error">
          <AlertTitle>Admin has encountered an error</AlertTitle>
          The error has been logged. Please refresh the page and try again.
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
